<app-loader />

@if (isUserAuthorized() && isReady()) {
  <app-layout>
    <router-outlet />
  </app-layout>
} @else if (isReady()) {
  <router-outlet />
}
